import { Typography } from '@design-system/components/typography/typography';
import { Checkbox } from '@design-system/components/checkbox/checkbox';
import { OtpBundlesVMData } from '../viewModel/otpBundles.viewModel';

export const FeaturesSection = ({
  features,
  disabled,
  value = [],
  onChange,
}: {
  features: OtpBundlesVMData['formData']['data']['features'];
  disabled: boolean;
  value?: number[] | null;
  onChange: (value: number[]) => void;
}) => (
  <div className="flex flex-col gap-4">
    <Typography variant="body" size="large" color={disabled ? 'N-60' : 'B-100'}>
      Features
    </Typography>
    <div className="flex flex-col md:flex-row gap-6 px-4">
      {features.options.map((f) => (
        <Checkbox
          key={f.id}
          label={f.name}
          checkboxVariant="neutral"
          checked={(value || []).includes(f.id)}
          onChange={() => {
            const newValues = features.toFormOnChange(f.id, value || []);
            onChange(newValues);
          }}
          disabled={disabled}
        />
      ))}
    </div>
  </div>
);
